export default __webpack_public_path__ + "static/media/training.686f03bd.png";